import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Input, OnInit } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { OwnerProfileGuestService } from '../owner-profile-guest.service';
import { OwnerProfileGuest } from '../owner-profile-guest';
import { OwnerProfileGuestComponent } from '../owner-profile-guest/owner-profile-guest.component';

@Component({
    selector: 'app-owner-profile-guest-list',
    templateUrl: './owner-profile-guest-list.component.html',
    styleUrls: ['./owner-profile-guest-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class OwnerProfileGuestListComponent implements OnInit {
    relationships: any;
	constructor(
		private ownerProfileGuestService: OwnerProfileGuestService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
	) {
		this.statuses = ownerProfileGuestService.statuses;
		this.relationships = ownerProfileGuestService.relationships;
	}



	// data
	@Input() ownerProfileId: any;
	@Input() showFilter = true;
	@Input() showPagination = true;
	ownerProfileGuests: any;
	ownerProfileGuest: OwnerProfileGuest;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	columns: any[] = [
		{ field: 'ownerProfileGuestId', header: 'Id', width: 'auto' },
		{ field: 'firstName', header: 'First Name', width: 'auto' },
		{ field: 'lastName', header: 'Last Name', width: 'auto' },
		{ field: 'emailAddress', header: 'Email Address', width: 'auto' },
		{ field: 'mobile', header: 'Status', width: 'auto' },
		{ field: 'relationship', header: 'Relationship', width: 'auto' },
		{ field: 'ownerProfileId', header: 'Owner Profile Id', width: 'auto' },
	];
	
	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.ownerProfileGuestId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-ownerProfileGuest-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}
			
			if(this.ownerProfileId)
			{
				// show only ownerProfiles that are assigned to this ownerProfileId
				let ownerProfileIdFilter = { 'ownerProfileId': { 'value': this.ownerProfileId, 'matchMode': 'in' } };
				Object.assign(event.filters, ownerProfileIdFilter);
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.ownerProfileGuestService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.ownerProfileGuests = res.data.ownerProfileGuests;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.ownerProfileGuests = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(ownerProfileGuest: OwnerProfileGuest) {
		try {
			this.formLoading = true;
			this.ownerProfileGuestService.update(ownerProfileGuest)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.ownerProfileGuests.map((ownerProfileGuest, i) => {
							if (ownerProfileGuest.ownerProfileGuestId === res.data.ownerProfileGuest.ownerProfileGuestId) {
								this.ownerProfileGuests[i] = res.data.ownerProfileGuest;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(ownerProfileGuest: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(ownerProfileGuest));

			this.formLoading = true;
			this.ownerProfileGuestService.delete(ownerProfileGuest.ownerProfileGuestId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.ownerProfileGuests.splice(this.ownerProfileGuests.indexOf(ownerProfileGuest), 1);
						this.recordTotal = this.ownerProfileGuests.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'OwnerProfileGuest ' + ownerProfileGuest.ownerProfileGuestId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'OwnerProfileGuest ' + ownerProfileGuest.ownerProfileGuestId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add OwnerProfileGuest'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(OwnerProfileGuestComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addOwnerProfileGuestCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(ownerProfileGuest: OwnerProfileGuest) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			ownerProfileGuest: ownerProfileGuest,
			title: 'Edit OwnerProfileGuest'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(OwnerProfileGuestComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateOwnerProfileGuestCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteOwnerProfileGuestCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addOwnerProfileGuestCB(ownerProfileGuest: OwnerProfileGuest) {
		console.log('Adding OwnerProfileGuest: ' + JSON.stringify(ownerProfileGuest));
		// if we don't have a ownerProfileGuests array yet...
		if (!this.ownerProfileGuests) {
			this.ownerProfileGuests = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.ownerProfileGuests.unshift(ownerProfileGuest);

		// no idea what this is but it is required to update the array
		this.ownerProfileGuests = [...this.ownerProfileGuests];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'OwnerProfileGuest ' + ownerProfileGuest.ownerProfileGuestId + ' Added', life: 3000 });
	}

	updateOwnerProfileGuestCB(ownerProfileGuest: OwnerProfileGuest) {
		console.log('Updating OwnerProfileGuest: ' + JSON.stringify(ownerProfileGuest));
		let itemIndex = this.ownerProfileGuests.findIndex((item: any) => item.ownerProfileGuestId === ownerProfileGuest.ownerProfileGuestId);
		this.ownerProfileGuests[itemIndex] = ownerProfileGuest;

		// no idea what this is but it is required to update the array
		this.ownerProfileGuests = [...this.ownerProfileGuests];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'OwnerProfileGuest ' + ownerProfileGuest.ownerProfileGuestId + ' Updated', life: 3000 });
	}

	deleteOwnerProfileGuestCB(ownerProfileGuest: OwnerProfileGuest) {
		console.log('Removing OwnerProfileGuest: ' + ownerProfileGuest);
		this.ownerProfileGuests.splice(this.ownerProfileGuests.indexOf(ownerProfileGuest), 1);
		this.recordTotal = this.ownerProfileGuests.length;

		// no idea what this is but it is required to update the array
		this.ownerProfileGuests = [...this.ownerProfileGuests];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'OwnerProfileGuest ' + ownerProfileGuest.ownerProfileGuestId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.ownerProfileGuests ? this.first === (this.ownerProfileGuests.length - this.rows) : true; }
	isFirstPage(): boolean { return this.ownerProfileGuests ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(ownerProfileGuest: any) {
		if (ownerProfileGuest?.status) {
			const status = this.statuses.find((e: any) => e.value == ownerProfileGuest.status);
			return status.name;
		}
		else {
			return '';
		}
	}
	
	getRelationshipName(ownerProfileGuest: any) {
		if (ownerProfileGuest?.relationship) {
			const relationship = this.relationships.find((e: any) => e.value == ownerProfileGuest.relationship);
			return relationship.name;
		}
		else {
			return '';
		}
	}
	
	reloadPage() {
		window.location.reload();
	}
}
